import { SpellingSuggestionType } from "@outschool/gql-frontend-generated";
import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";

const spellingSuggestionsQuery = gql`
  query SpellingSuggestion(
    $query: String!
    $spellingSuggestionType: SpellingSuggestionType
  ) {
    spellingSuggestion(
      query: $query
      spellingSuggestionType: $spellingSuggestionType
    ) {
      query
      highConfidence
      spellingSuggestion
    }
  }
`;

export function useSpellingSuggestion({
  query,
  spellingSuggestionType,
}: {
  query: string;
  spellingSuggestionType: SpellingSuggestionType;
  spellingSuggestionExp?: boolean;
}) {
  const { data, loading } = useQueryWithPreviousData(spellingSuggestionsQuery, {
    variables: {
      query,
      spellingSuggestionType,
    },
  });

  return { suggestion: data?.spellingSuggestion, loading };
}
